import React, { useContext, useState } from "react";
import { homeDashBoardCardTypes } from "./Shared/Constants";
import useHomeDashBoardDetails from "../../../hooks/HomeDashBoard/useHomeDashBoardDetails";
import {
  getCurrentYearPlanningCount,
  getPlanningCompletedCount,
  getProcedureApprovePendingCount,
  getProcedureCompletedCount,
  getProcedureInProgressCount,
  getProcedureReviewPendingCount,
} from "../../../Services/DashBoard.Services";
import { dashBoardCardData } from "./Shared/DashboardCard.data";
import { useTranslate } from "../../../hooks/translation/useTranslationHook";
import { GlobalStateContext } from "../../../Context/GlobalStateContext";
import { accessLevels } from "../../../Helpers/helper";
import { useMenuList } from "../../../hooks/common/useMenuList";
import useActiveClients from "../../../hooks/HomeDashBoard/useActiveClients";
import { DashboardCardWithChild } from "./Shared/DashboardCardWithChild";
import { DashboardCardWithoutChild } from "./Shared/DashboardCardWithoutChild";
import DashboardCardPopup from "./Shared/DashboardCardPopup";

export const DashboardCard = () => {
  const { t } = useTranslate();
  const { menuListArr } = useMenuList();
  const { globalState } = useContext(GlobalStateContext);
  const clientAndFiscalYearsData = globalState?.clientFiscalYears || {};
  const { currentFiscalYear = { id: 0, value: "" } } = clientAndFiscalYearsData;
  const cardDetails = dashBoardCardData(
    t,
    menuListArr,
    accessLevels.AccessView
  );

  const [popUpOpen, setPopUpOpen] = useState(false);
  const [itemDetails, setItemDetails] = useState({
    type: "",
    label: "",
    hasScreenPermission: false,
    screenData: [],
  });

  const dashboardData = {
    planningCompleted: useHomeDashBoardDetails(
      currentFiscalYear?.fiscalYearID,
      getPlanningCompletedCount,
      "planningCompletedCount",
      homeDashBoardCardTypes.PlanningCompleted
    ),
    currentYear: useHomeDashBoardDetails(
      currentFiscalYear?.fiscalYearID,
      getCurrentYearPlanningCount,
      "currentYearPlanningCount",
      homeDashBoardCardTypes.CurrentYearPlanning
    ),
    procedureCompleted: useHomeDashBoardDetails(
      currentFiscalYear?.fiscalYearID,
      getProcedureCompletedCount,
      "procedureCompletedCount",
      homeDashBoardCardTypes.ProcedureCompleted
    ),
    procedureInProgress: useHomeDashBoardDetails(
      currentFiscalYear?.fiscalYearID,
      getProcedureInProgressCount,
      "procedureInProgressCount",
      homeDashBoardCardTypes.ProcedureInProgress
    ),
    procedureReviewPending: useHomeDashBoardDetails(
      currentFiscalYear?.fiscalYearID,
      getProcedureReviewPendingCount,
      "procedureReviewPendingCount",
      homeDashBoardCardTypes.ProcedureReviewPending
    ),
    procedureApprovePending: useHomeDashBoardDetails(
      currentFiscalYear?.fiscalYearID,
      getProcedureApprovePendingCount,
      "procedureApprovePendingCount",
      homeDashBoardCardTypes.ProcedureApprovePending
    ),
  };

  const { clientListLoading, clientActiveList, clientListStatus } =
    useActiveClients(currentFiscalYear?.fiscalYearID || 0);

  const handlePopupClick = (item) => {
    setItemDetails({
      type: item.type,
      label: item.displayLabel,
      hasScreenPermission: item.hasScreenPermission,
      screenData: item.screenData,
    });
    setPopUpOpen(true);
  };

  return (
    <div className="grid-container">
      {cardDetails.map((item, index) =>
        item.children ? (
          <DashboardCardWithChild
            key={`home-header-card-${index}`}
            item={item}
            handleOnClick={() => {}}
            clientActiveList={clientActiveList}
            clientListLoading={clientListLoading}
            hasChild={true}
            clientListStatus={clientListStatus}
          />
        ) : (
          <DashboardCardWithoutChild
            key={`home-header-card-${index}`}
            item={item}
            handleOnClick={() => handlePopupClick(item)}
            dashboardData={dashboardData}
            menuListArr={menuListArr}
            popUpOpen={popUpOpen}
            setPopUpOpen={setPopUpOpen}
            currentFiscalYearId={currentFiscalYear?.fiscalYearID}
            t={t}
            hasChild={false}
          />
        )
      )}
      {popUpOpen && (
        <DashboardCardPopup
          popUpOpen={popUpOpen}
          setPopUpOpen={setPopUpOpen}
          itemDetails={itemDetails}
          setItemDetails={setItemDetails}
          currentFiscalYearId={currentFiscalYear?.fiscalYearID}
          startDate={currentFiscalYear?.startDate}
          endDate={currentFiscalYear?.endDate}
          t={t}
        />
      )}
    </div>
  );
};
